<template>
  <b-overlay
    :show="loader"
    rounded="sm"
  >
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>
          <feather-icon icon="FilterIcon" /> Filtros
        </h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col
            cols="6"
            class="mb-md-0 mb-2"
          >
            <label>Cursos Visibles</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="statusFilter2"
              :options="statusOptions2"
              class="w-100"
              :reduce="val => val.value"
              @input="(val) => $emit('update:statusFilter2', val)"
            />
          </b-col>
          <b-col
            cols="6"
            class="mb-md-0 mb-2"
          >
            <label>Actividades Visibles</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="statusFilter"
              :options="statusOptions"
              class="w-100"
              :reduce="val => val.value"
              @input="(val) => $emit('update:statusFilter', val)"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="6"
            class="mt-2 mb-md-0 mb-2"
          >
            <selectplan
              @selectedplan="idplan=$event, $emit('planfilter', $event)"
            />
          </b-col>
          <b-col
            cols="6"
            class="mt-2 mb-md-0 mb-2"
          >
            <selectperiodo
              :idplan="idplan"
              @selectedperiodo="$emit('periodofilter', $event)"
            />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import selectplan from '@/views/components/select-plan.vue'
import selectperiodo from '@/views/components/select-periodos.vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BOverlay,
    selectplan,
    selectperiodo,
  },
  props: {
    statusFilter: {
      type: [String, null],
      default: null,
    },
    statusFilter2: {
      type: [String, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    statusOptions2: {
      type: Array,
      required: true,
    },
    loader: {
      type: Boolean,
      default: false,
    },
    plan: {
      type: [Array, null],
      default: null,
    },
  },
  setup() {
    const idplan = ref(null)
    return {
      idplan,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
